var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2375 4899 c-782 -64 -1478 -510 -1864 -1196 -324 -576 -385 -1281 -167 -1912 116 -334 288 -611 540 -869 705 -723 1792 -913 2701 -472 491 239 898 659 1115 1150 358 809 242 1724 -306 2422 -129 164 -385 396 -564 510 -199 127 -446 236 -665 293 -166 44 -277 62 -445 75 -150 11 -199 11 -345 -1z m263 -1075 c44 -18 87 -57 110 -99 15 -26 18 -86 22 -490 l5 -460 460 -5 c503 -5 487 -3 547 -67 76 -80 76 -206 0 -286 -60 -64 -44 -62 -547 -67 l-460 -5 -5 -460 c-5 -503 -3 -487 -67 -547 -80 -76 -206 -76 -286 0 -64 60 -62 44 -67 547 l-5 460 -460 5 c-503 5 -487 3 -547 67 -76 80 -76 206 0 286 60 64 44 62 547 67 l460 5 5 460 c5 503 3 487 67 547 59 56 148 73 221 42z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.99c103e9b190de044a0a77366011e455.svg";
export { ForwardRef as ReactComponent };